import Routes from '@constants/routes.enum';
import { Container } from '@mui/material';
import { rootRoute } from '@rootScreen';
import { createRoute } from '@tanstack/react-router';
import React from 'react';

const Help = () => {
  return (
    <Container
      className="m-0 px-2 !pl-2 overflow-y-scroll flex flex-col !h-full relative gap-2"
      maxWidth={false}
      sx={{ placeContent: 'start' }}
    ></Container>
  );
};
export const helpRoute = createRoute({
  component: Help,
  getParentRoute: () => rootRoute,
  path: Routes.HELP,
});
export default Help;
